<template>
    <div class="account-members" :class="{loading: loading}">
        <fieldset>
            <legend>
                <div class="row">
                    <div class="col-sm-6 col-md-7 text-right form-group pull-sm-right">
                        Account Members
                    </div>

                    <div class="col-sm-6 col-md-5 form-group align-sm-left">
                        <button type="button" class="btn btn-success" @click="() => isMultiSignature ? null : open(null)" :disabled="isMultiSignature || loading">
                            Add Member
                        </button>
                    </div>
                </div>
            </legend>

            <div class="form-group text-right">
                <div class="checkbox">
                    <label>
                        <input v-model.boolean="archived"
                               type="checkbox"
                               id="archived"
                               name="archived">
                        Show Archived
                    </label>
                </div>
            </div>

            <h4 v-if="Array.isArray(leaseMembers) && leaseMembers.length > 0">Lease Members</h4>

            <div class="list-group" v-if="Array.isArray(leaseMembers) && leaseMembers.length > 0">
                <a href="javascript://void(0)" class="list-group-item"
                   :class="{'list-group-item-success active':selectedModelId === leaseMember.id}"
                   v-for="leaseMember in leaseMembers"
                   :key="leaseMember.id"
                   @click="open(leaseMember.id)">
                    <span v-if="leaseMember.archivedLabel" v-html="leaseMember.archivedLabel"></span>

                    <ul class="list-unstyled">
                        <li v-for="resident in leaseMember.accountable.residents" :key="resident.id">
                            <a :href="'/residents/' + resident.id">
                                {{resident.first_name}} {{resident.last_name}}
                            </a>
                        </li>
                    </ul>
                </a>
            </div>

            <h4 v-if="Array.isArray(userMembers) && userMembers.length > 0">User Members</h4>

            <div class="list-group" v-if="Array.isArray(userMembers) && userMembers.length > 0">
                <a href="javascript://void(0)" class="list-group-item"
                   :class="{'list-group-item-success active':selectedModelId === userMember.id}"
                   v-for="userMember in userMembers"
                   :key="userMember.id"
                   @click="open(userMember.id)">
                    <h5 class="list-group-item-heading">
                        {{userMember.accountable.fullName}} <span class="label label-warning">User</span>
                        <span v-if="userMember.archivedLabel" v-html="userMember.archivedLabel"></span>
                    </h5>
                    <h6>({{userMember.accountable.email}})</h6>
                </a>
            </div>
        </fieldset>

        <account-member ref="accountMemberComponent"
                        :account="account"
                        :account-id="accountId"
                        :accountable-id="accountableId"
                        :accountable-type="accountableType"
                        :model-id="selectedModelId"
                        :project-id="projectId"
                        :is-multi-signature="isMultiSignature"
                        @afterSave="afterSave">
            <span></span>
        </account-member>
    </div>
</template>

<script>
    import models from "./mixins/models";
    import AccountMember from "./AccountMember";

    export default {
        components: { AccountMember },
        mixins: [ models ],

        props: {
            account: {
                required: true,
                type: Object
            },

            isMultiSignature: {
                required: true,
                type: Boolean
            },

            accountId: {
                type: String,
                required: true
            },

            accountableId: {
                type: String,
                required: true
            },

            accountableType: {
                type: String,
                required: true
            },

            projectId: {
                type: String,
                required: true
            },
        },

        computed: {
            leaseMembers(){
                if( this.models ){
                    return _.filter( this.models, { accountable_type: 'App\\Lease' } );
                }
            },

            userMembers(){
                if( this.models ){
                    return _.filter( this.models, { accountable_type: 'App\\User' } );
                }
            },

            url(){
                return '/api/accountMembers?account_id=' + this.accountId + '&_load[]=accountable';
            },

            modelComponent(){
                return 'accountMemberComponent';
            },

            resourceKey(){
                return 'AccountMembers';
            },
        },

        methods: {
            afterSave(){
                this.$emit( 'afterSave' );

                this.init();
            },
        },

        watch: {
            archived(){
                this.load();
            }
        },
    }
</script>
